import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const MCCERTS_2972_SUBS_ONLY_CLP_I18N_NAMESPACE =
  '@mc/next/experiments/mccerts-2972-subs-only-clp-v1'

export const i18nInstance = registerI18nResources({
  namespace: MCCERTS_2972_SUBS_ONLY_CLP_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
